import { render, staticRenderFns } from "./Wrongbook.vue?vue&type=template&id=49ffaecc&scoped=true"
import script from "./Wrongbook.vue?vue&type=script&lang=js"
export * from "./Wrongbook.vue?vue&type=script&lang=js"
import style0 from "./Wrongbook.vue?vue&type=style&index=0&id=49ffaecc&prod&lang=scss&scoped=true"
import style1 from "./Wrongbook.vue?vue&type=style&index=1&id=49ffaecc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ffaecc",
  null
  
)

export default component.exports